export default __webpack_public_path__ + "static/espaco-gourmet-detalhe-79d1cb5bcab12163ce6716e1f32c96fb.jpg";